import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Uploader from "./uploader";
import { FilePicker } from "react-file-picker";

import {
  Divider,
  Drawer,
  Hidden,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Badge,
  AppBar,
  Toolbar,
  Button,
  Dialog,
  IconButton,
  Typography,
  Grid,
  Card,
  CardContent,
} from "material-ui";

import { withStyles } from "material-ui/styles";

import {
  Done as DoneIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
} from "material-ui-icons";
//import MenuIcon from 'material-ui-icons/Menu';
//import CloseIcon from 'material-ui-icons/Close';

import classNames from "classnames";

import Loading from "../../../../utils/loading/Loading";
import Retry from "../../../../utils/retry/Retry";

import {
  getCategoriesRequest,
  getCategoryVideosRequest,
  getCategoriesDone,
} from "./actions";

import styles from "./VideoChooser.scss";
import poster1 from "../../../posterImage/thumb.png";
import uploader from "./uploader";
import { capitalizeFirstLetter } from "../../../../patientplaylist/PatientPlaylistTools";

const drawerWidth = 240;
const stylesForDrawer = (theme) => ({
  badge: {
    [theme.breakpoints.down("sm")]: {
      right: -8,
    },
    // right: -8,
    // transform: 'scale(1.4) translate(50%, -50%)'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  listItemTextSelected: {
    color: "red",
    fontWeight: "bold",
  },
  listItemTextUnselected: {
    color: "black",
  },
  videoContainer: {
    [theme.breakpoints.up("md")]: {
      marginLeft: drawerWidth,
    },
  },
  navIconCategoryHide: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  navIconCloseHide: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  toolbar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
    },
  },
});

class VideoChooser extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    handleSave: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    admin: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        specialityId: PropTypes.string.isRequired,
      }),
      subcription: PropTypes.shape({
        accountStatus: PropTypes.shape({
          isTrialExpired: PropTypes.bool,
          isCardAdded: PropTypes.bool,
          isSubscriptionExpired: PropTypes.bool,
          remaningTrialDays: PropTypes.number,
          stripeCurrentPeriodEnd: PropTypes.string,
        }),
      }),
    }).isRequired,
    "video-chooser": PropTypes.objectOf(PropTypes.any).isRequired,
    getCategoriesRequest: PropTypes.func.isRequired,
    getCategoryVideosRequest: PropTypes.func.isRequired,
    getCategoriesDone: PropTypes.func.isRequired,
  };

  static defaultProps = {
    open: false,
  };

  state = {
    selectedCategory: undefined,
    wallVideo: undefined,
    videos: [],
    mobileOpen: true,
    videoUploaderProgress: false,
  };

  componentDidMount() {
    this.getCategories();
    let typeWallVideo = this.props.match.params.wall;
    if (typeWallVideo == "false") {
      typeWallVideo = false;
      this.setState({
        wallVideo: typeWallVideo,
      });
    } else {
      typeWallVideo = true;
      this.setState({
        wallVideo: typeWallVideo,
      });
    }
    console.log("Selection pour le tableau : ", this.state.wallVideo);
  }

  componentWillUnmount() {
    this.props.getCategoriesDone();
  }

  getCategories = (force) => {
    if (
      typeof this.props["video-chooser"].categories === "undefined" ||
      force
    ) {
      const { id: accessToken } = this.props.login.authData;
      const { specialityId } = this.props.admin.user;
      console.log("specialityId", specialityId);
      //  alert(specialityId)
      this.props.getCategoriesRequest({
        accessToken,
        specialityId: specialityId,
        userId: this.props.login.authData.userId,
      });
    }
  };

  handleSave = () => {
    this.props.handleSave(this.state.videos);

    this.handleClose();
  };

  handleOnEnter = () => {
    this.setState({ mobileOpen: true });
  };
  handleClose = () => {
    this.props.handleClose();

    this.props.getCategoriesDone();

    this.setState({ selectedCategory: undefined, videos: [] });
  };

  handleRetryCategories = () => {
    this.props.getCategoriesRequest();
  };

  handleRetryCategoryVideos = () => {
    const { id: accessToken } = this.props.login.authData;
    this.props.getCategoryVideosRequest({
      userId: this.props.login.authData.userId,
      accessToken,
      categoryId: this.state.selectedCategory.id,
    });
  };

  selectCategory = (category) => {
    if (
      this.state.selectedCategory === undefined ||
      category.id !== this.state.selectedCategory.id
    ) {
      this.setState({
        selectedCategory: category,
      });

      const { id: accessToken } = this.props.login.authData;
      this.props.getCategoryVideosRequest({
        userId: this.props.login.authData.userId,
        accessToken,
        categoryId: category.id,
      });
      this.handleDrawerToggle();
    }
  };

  toggleVideo = (video) => {
    const { videos } = this.state;
    if (videos.some((e) => e.id === video.id)) {
      this.setState({
        videos: videos.filter((v) => v.id !== video.id),
      });
      return;
    }

    this.setState({
      videos: [...videos, video],
    });
  };

  handleDrawerToggle = () => {
    this.setState((state) => ({ mobileOpen: !state.mobileOpen }));
  };
  videoSelectedInCategory(categoryId) {
    return this.state.videos.filter((e) => e.categoryId === categoryId).length;
  }
  videoSelectedInCategoryCount(categoryId) {
    return this.state.videos.some((e) => e.categoryId === categoryId);
  }

  async handleUploadCustomVideo(FileObject) {
    this.setState({
      videoUploaderProgress: true,
    });
    const { id: accessToken, userId } = this.props.login.authData;
    let result = null;
    try {
      result = await Uploader.upload(
        "mp4",
        FileObject,
        userId,
        this.state.selectedCategory.id,
        accessToken
      );
    } catch (error) {
      this.setState({
        videoUploaderError: true,
        videoUploaderProgress: false,
      });
      console.log("Videouploadererror", error);
    }
    console.log("videoUploaderSuccess", result);
    this.setState({
      videoUploaderProgress: false,
    });
    this.handleRetryCategoryVideos();
  }

  render() {
    const {
      "video-chooser": {
        categoriesRequesting,
        categoriesSuccessful,
        categoriesError,
        categories,
        categoryVideosRequesting,
        categoryVideosSuccessful,
        categoryVideosError,
        videos,
      },
    } = this.props;
    const { classes, theme } = this.props;
    const { selectedCategory } = this.state;
    if (this.state.selectedCategory !== undefined)
      console.log(this.state.selectedCategory);

    let filteredVideos = [];

    if (typeof videos != "undefined" && videos.length) {
      filteredVideos = videos.filter((video) => {
        return (
          !video.autoGenerated ||
          video.autoGeneratedForVideoWall == this.state.wallVideo
        );
      });
    }

    const drawer = (
      <div>
        <div className={classes.toolbar}>
          {/* <AppBar className={styles.sticky}> */}
          <Toolbar color="inherit">
            <IconButton
              color="inherit"
              onClick={this.handleClose}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
            <Typography type="title" color="inherit" className={styles.flex}>
              Quitter
            </Typography>
          </Toolbar>
          {/* </AppBar> */}
          {/* <div className={classes.toolbar} /> */}
        </div>
        <Divider />
        <List>
          {categoriesSuccessful &&
            categories.map((category) => {
              if (category.videoCount || category.slug == "mes-videos") {
                return (
                  <ListItem
                    button
                    key={category.name}
                    onClick={() => this.selectCategory(category)}
                  >
                    <ListItemText
                      primary={category.name}
                      classes={{
                        primary:
                          this.state.selectedCategory !== undefined &&
                          category.name == this.state.selectedCategory.name
                            ? classes.listItemTextSelected
                            : classes.listItemTextUnSelected,
                      }}
                      // primaryTypographyProps={{
                      //   style :
                      //   ( this.state.selectedCategory !== undefined && category.name == this.state.selectedCategory.name ) ?
                      //     { color: 'red', fontWeight: 'bold' } :
                      //     { color: 'black'}
                      // }}
                    />
                    <Badge
                      badgeContent={
                        category.videoCount -
                        this.videoSelectedInCategory(category.id)
                      }
                      color={
                        this.videoSelectedInCategory(category.id)
                          ? "primary"
                          : "secondary"
                      }
                      classes={{ badge: classes.badge }}
                    >
                      {" "}
                    </Badge>
                  </ListItem>
                );
              }
            })}
        </List>
      </div>
    );

    // console.log(JSON.stringify(videos));
    return (
      <Dialog
        disableEnforceFocus
        fullScreen
        open={this.props.open}
        onClose={this.handleClose}
        onEnter={this.handleOnEnter}
        transition={this.Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.navIconCategoryHide}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              type="title"
              color="inherit"
              className={classNames({
                [classes.navIconCategoryHide]: true,
                [styles.flex]: true,
              })}
            >
              Catégories
            </Typography>

            <IconButton
              color="inherit"
              onClick={this.handleClose}
              className={classes.navIconCloseHide}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
            <Typography
              type="title"
              color="inherit"
              className={classNames({
                [classes.navIconCloseHide]: true,
                [styles.flex]: true,
              })}
            >
              Quitter
            </Typography>

            <Button color="inherit" onClick={this.handleSave}>
              Enregistrer
            </Button>
          </Toolbar>
        </AppBar>

        <div className={classes.videoContainer}>
          <div className={classNames({ [styles.container]: true, mt4: true })}>
            <nav aria-label="categories">
              <Hidden mdUp>
                <Drawer
                  variant="temporary"
                  anchor="left"
                  open={this.state.mobileOpen}
                  onClose={this.handleDrawerToggle}
                  classes={{
                    paper: classes.drawerPaper,
                  }}
                  ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                  }}
                >
                  {drawer}
                </Drawer>
              </Hidden>

              <Hidden smDown implementation="css">
                <Drawer
                  classes={{
                    paper: classes.drawerPaper,
                  }}
                  variant="permanent"
                  open
                >
                  {drawer}
                </Drawer>
              </Hidden>
            </nav>

            <div>
              {this.state.selectedCategory === undefined && (
                <div>
                  <Typography
                    type="display1"
                    align="center"
                    className="mb3 mt4"
                  >
                    Choisissez une catégorie
                  </Typography>
                </div>
              )}
              {categoryVideosSuccessful && (
                <div>
                  <p
                    style={{
                      textAlign: "center",
                      color: "#2196F3",
                      fontWeight: "bold",
                    }}
                  >
                    {this.state.selectedCategory.name}
                  </p>
                  <Typography
                    type="display1"
                    align="center"
                    className="mb3 mt4"
                  >
                    Choix des vidéos
                  </Typography>
                </div>
              )}
              <Grid className="mt4" container justify="space-around">
                {categoryVideosRequesting && <Loading size={80} />}
                {categoryVideosError && (
                  <Retry
                    message={categoryVideosError}
                    onRetry={this.handleRetryCategoryVideos}
                  />
                )}
                {categoryVideosSuccessful && !videos.length && (
                  <p style={{ textAlign: "center", color: "black" }}>
                    Il n'y a pas encore de vidéos dans cette catégorie.
                  </p>
                )}
                {categoryVideosSuccessful &&
                  filteredVideos.map(
                    (video) => (
                      console.log("VIDEOS : ", this.state.wallVideo),
                      console.log("VIDEO : ", video),
                      (
                        <Card
                          key={video.id}
                          className={classNames({ [styles.cardVideo]: true })}
                          onClick={(e) => {
                            // Prevent event bubbling
                            if (
                              e.target.classList[0] &&
                              e.target.classList[0].startsWith("rh5v")
                            ) {
                              return;
                            }
                            this.toggleVideo(video);
                          }}
                        >
                          <CardContent
                            className={classNames({
                              [styles.contentVideo]: true,
                              [styles.selectedVideo]: this.state.videos.some(
                                (e) => e.id === video.id
                              ),
                            })}
                          >
                            <div style={{ position: "relative" }}>
                              <video
                                controls={[
                                  "PlayPause",
                                  "Seek",
                                  "Time",
                                  "Volume",
                                  "Fullscreen",
                                ]}
                                controlsList="nodownload"
                                src={video.file}
                                poster={
                                  video.posterImage === undefined
                                    ? poster1
                                    : video.posterImage
                                }
                                className={styles.videoPlayWrapper}
                                preload="none"
                              />
                              {/* {video.duration && <Typography component="p" className={styles.videoDuration}>{video.duration}</Typography>} */}
                            </div>
                            {/* {console.log(video)} */}
                            <Typography
                              style={{ textAlign: "left" }}
                              type="headline"
                              component="h5"
                              className={"mt1 " + styles.maxTwoLines}
                            >
                              {!video.autoGenerated && video.videoTitle
                                ? video.videoTitle
                                : ""}
                              {!video.autoGenerated && <br />}
                              {video.description
                                ? capitalizeFirstLetter(video.description)
                                : ""}
                            </Typography>
                            {/* <Typography component="p" className={styles.textOverflow}>{video.description}</Typography> */}

                            <DoneIcon
                              className={classNames({
                                [styles.selectedVideoIcon]: true,
                                hidden: !this.state.videos.some(
                                  (e) => e.id === video.id
                                ),
                              })}
                            />
                          </CardContent>
                        </Card>
                      )
                    )
                  )}
                {this.state.selectedCategory &&
                  this.state.selectedCategory.slug == "mes-videos" && (
                    <div
                      style={{
                        width: "100%",
                        marginTop: "30px",
                        textAlign: "center",
                      }}
                    >
                      {!this.state.videoUploaderProgress && (
                        <FilePicker
                          extensions={["mp4"]}
                          maxSize={300}
                          onChange={(FileObject) => {
                            this.setState({
                              videoUploaderError: false,
                            });
                            this.handleUploadCustomVideo(FileObject);
                          }}
                          onError={(errMsg) => {
                            console.log("Message d'erreur", errMsg);
                            this.setState({
                              videoUploaderError: true,
                            });
                          }}
                        >
                          <Button
                            variant={"raised"}
                            type={""}
                            color="primary"
                            aria-label="Ajouter une vidéo"
                            className={styles.textbutton}
                          >
                            Ajouter une vidéo
                          </Button>
                        </FilePicker>
                      )}
                      {this.state.videoUploaderProgress && (
                        <p style={{ color: "green" }}>
                          Téléversement en cours, veuillez patienter...
                          <br />
                          (ceci peut être long en fonction de votre taille de
                          fichier et votre connexion)
                        </p>
                      )}
                      {this.state.videoUploaderError && (
                        <p style={{ color: "red" }}>
                          Une erreur s'est produite, veuillez réessayer
                          <br />
                          (Uniquement les fichiers au format .mp4 sont
                          supportés. La taille maximum est de 300mo.)
                        </p>
                      )}
                    </div>
                  )}
              </Grid>
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => ({
  "video-chooser": state["video-chooser"],
  login: state.login,
  admin: state.admin,
});

export default withStyles(stylesForDrawer, { withTheme: true })(
  connect(mapStateToProps, {
    getCategoriesRequest,
    getCategoryVideosRequest,
    getCategoriesDone,
  })(withRouter(VideoChooser))
);



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/video-chooser/VideoChooser.jsx